module.exports = __webpack_public_path__ + "img/icon-payment-app.21514076.png";